import * as yup from 'yup';
import { checkoutSchema as checkout } from './checkout';
import {
  onboardingIntroSchema as onboarding_intro,
  pupName as pup_name_form,
  pupGender as pup_gender_form,
  pupBreed as pup_breed_form,
  pupStatus as pup_status_form,
  weight as weight_form,
  activity as activity_form,
  allergies as allergies_form,
  extras as extras_form,
  userInfoSchema as user_info_form,
  giftWithPurchase as gift_with_purchase_form,
  quizAbandonerMenuSchema as abandoner_menu,
} from './quiz';
import { recommendedPlanSchema as recommended_plan } from './plan';
import { addonSchema as extras } from './addons';

const redirect_route = yup.object({});

export {
  redirect_route,
  recommended_plan,
  extras,
  checkout,
  onboarding_intro,
  pup_name_form,
  pup_gender_form,
  pup_breed_form,
  pup_status_form,
  weight_form,
  activity_form,
  allergies_form,
  extras_form,
  user_info_form,
  gift_with_purchase_form,
  abandoner_menu,
};
